import { rem } from 'polished'
import styled from 'styled-components'

import LuxuryEscapesSmallLogo from 'components/App/Header/Logo/logos/LuxuryEscapesSmallLogo'
import Clickable from 'components/Common/Clickable'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import zIndex from 'styles/tools/z-index'
import { headerHeight } from 'tripPlanner/config'

export const TripPlannerStickyHeader = styled.header`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: ${headerHeight.sm};
  background: ${({ theme }) => theme.palette.neutral.default.eight};
  z-index: ${zIndex.stickyHeader};
  padding: 0 ${rem(16)};
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.withShadow {
    box-shadow: ${({ theme }) => theme.shadow.bottom.small};
  }

  ${mediaQueryUp.desktop} {
    height: ${headerHeight.lg};
  }

  @media print {
    display: none;
  }
`

export const TripPlannerHeaderCentreContent = styled(Clickable)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  &:not(:disabled) {
    &:hover {
      background-color: unset;
      border-color: transparent;
      color: unset;
    }
  }
`

export const TripPlannerStyledLogo = styled(LuxuryEscapesSmallLogo)`
  width: ${rem(36)};
  height: ${rem(36)};
`

export const LeftContent = styled.div`
  justify-self: flex-start;
  display: flex;
  flex-shrink: 1;
  min-width: 48px;
  align-items: center;
  gap: ${rem(8)};
`

export const RightContent = styled.div`
  justify-self: flex-end;
  display: flex;
  align-items: center;

  gap: ${rem(8)};
  margin-left: ${rem(16)};
`

export const FlexBreakpoint = styled(CSSBreakpoint)`
  display: flex;
  align-items: center;
`
